import request from "../Tools/request/request";

// 应用上架-列表
export function getAppAuditList(data) {
    return request({
        url: "/supermarket/app-on/list",
        method: "post",
        data,
    });
}

// 应用上架-审核
export function getAppAudit(data) {
    return request({
        url: "/supermarket/app-review/on",
        method: "post",
        data,
    });
}

// 应用上传 - 列表
export function getAppUploadAuditList(data) { 
       return request({
        url: "/supermarket/app/page",
        method: "post",
        data,
    });
}

// 应用上传 - 审核
export function getAppUploadAudit(data) {
    return request({
        url: "/app/uploadReview",
        method: "post",
        data,
    })
}


// 构建应用-列表
export function getLowcodeList(data) {
    return request({
        url: "/lowcode/list/review",
        method: "post",
        data,
    });
}

// 构建应用-审核
export function getLowcodeAudit(data) {
    return request({
        url: "/lowcode/result/review",
        method: "post",
        data,
    });
}
// 应用信息-列表
export function getAppInfoList(data) {
    return request({
        url: "/supermarket/app-on/list",
        method: "post",
        data,
    });
}

// 应用信息-上架
export function getAppInfoOn(data) {
    return request({
        url: "/supermarket/app/on",
        method: "post",
        data,
    });
}

// 应用信息-下架/删除
export function getAppInfoOff(data) {
    return request({
        url: "/supermarket/app/down",
        method: "post",
        data,
    });
}

// 应用信息-下架/删除
export function getAppInfoDel(data) {
    return request({
        url: "/supermarket/app-on/del",
        method: "post",
        data,
    });
}

// 应用咨询-列表
export function getAppConsultList(data) {
    return request({
        url: "/portal/ask/list",
        method: "post",
        data,
    });
}

// 定制咨询-列表
export function getDIYConsultList(data) {
    return request({
        url: "/supermarket/made-ask/list",
        method: "post",
        data,
    });
}

// 应用评价-列表
export function getAppEvalautionList(data) {
    return request({
        url: "/community/reply/list",
        method: "post",
        data,
    });
}

// 应用评价-删除
export function getAppEvalautionDel(data) {
    return request({
        url: "/community/app-discuss/del",
        method: "post",
        data,
    });
}

// 定制咨询-跟进
export function getDIYConsultReview(data) {
    return request({
        url: "/supermarket/made-ask/update",
        method: "post",
        data,
    });
}

// 用户应用管理-列表
export function getUserAppList(data) {
    return request({
        url: "/supermarket/app/openlist",
        method: "post",
        data,
    });
}
// 服务商管理-列表
export function getServiceList(data) {
    return request({
        url: "/supermarket/server/list",
        method: "post",
        data,
    });
}
// 服务商管理-启用/禁用
export function getServiceStopOrStart(data) {
    return request({
        url: "/supermarket/server/operate",
        method: "post",
        data,
    });
}

// 新增应用
export function getAddApp(data) {
    return request({
        url: "/supermarket/app/on",
        method: "post",
        data,
    });
}

// 获取应用图片
export function getAppIconList(data) {
    return request({
        url: "/qiniuyun/public/app-image/list",
        method: "post",
        data,
    });
}



// 获取应用信息管理-详情-应用开通列表
export function getAppInfoDetail(data) {
    return request({
        url: "/supermarket/app/open-member/list",
        method: "post",
        data,
    });
}